import FormType from "../../Components/Form2/FormType";

const ContactFormOptions = (init) => {
 return {
  Fields: [
   {
    element: FormType.Input,
    required: true,
    name: "companyName",
    label: "Company Name",
    value: init.companyName,
    disabled: true,
   },
   [
    {
     element: FormType.Input,
     required: true,
     name: "firstname",
     label: "First Name",
     value: init.firstname || "",
    },
    {
     element: FormType.Input,
     required: true,
     name: "lastname",
     label: "Last Name",
     value: init.lastname || "",
    },
   ],
   {
    element: FormType.Input,
    required: true,
    name: "phone",
    label: "Phone",
    value: init.phone || "",
   },
   {
    element: FormType.Input,
    required: true,
    label: "Email",
    name: "email",
    value: init.email || "",
   },
   {
    element: FormType.RadioGroup,
    name: "siteType",
    label: "Site Type",
    options: [
     { label: "Residential", value: 1 },
     { label: "Office", value: 2 },
    ],
    value: init.siteType, 
    changeEvent: true,
    required: true,
   },
   {
    element: FormType.Input,
    required: true,
    name: "siteAddress",
    label: "Site Address",
    value: init.siteAddress || "",
    required: true
   },
  ],
 };
};

export default ContactFormOptions;